





























































































































































import Vue from "vue";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import { ValidationObserver } from "vee-validate";
import { snakeCase } from "lodash";
import HttpClient from "../../../../services/HttpClient";
import Receiver from "../../../../types/receivers/Receiver";
import CreateReceiverResponse from "../../../../types/receivers/api/CreateReceiverResponse";
import { DeliveryData } from "../../../../types/receivers/deliveryTypes/DeliveryData";

export default Vue.extend({
  data() {
    return {
      httpClient: {} as HttpClient,
      receiver: {
        id: null,
        deliveryType: "",
        deliveryData: {} as DeliveryData,
        companyName: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        registrationNumber: "",
      } as Receiver,
    };
  },

  created() {
    this.httpClient = HttpClientFactory.getInstance();
  },
  methods: {
    async validate() {
      const validated = await (
        this.$refs.form as InstanceType<typeof ValidationObserver>
      ).validate();
      if (!validated) {
        return false;
      }

      if (!this.receiver.id) {
        try {
          const response: CreateReceiverResponse = await this.httpClient.post(
            process.env.VUE_APP_BACKEND_ENDPOINT + "/receivers/v1",
            this.receiver
          );
          this.receiver.id = response.data.id;
          this.$emit("on-receiver-created", this.receiver.id);
          const succes: any = {
            text: this.$t("receiver:saved"),
            type: "success",
          };
          this.$notify(succes);
          return true;
        } catch (e) {
          const arrayOfErrors: any[] = e.response.data.errors;
          arrayOfErrors.forEach((error: any) => {
            this.showValidationError(snakeCase(error.field), snakeCase(error.rule));
          });
          return false;
        }
      }

      return await this.updateReceiver(this.receiver.id);
    },
    async updateReceiver(receiverId: number) {
      try {
        await this.httpClient.put(
          process.env.VUE_APP_BACKEND_ENDPOINT + `/receivers/v1/${receiverId}`,
          this.receiver
        );
        const success: any = {
          text: this.$t("receiver:saved"),
          type: "success",
        };
        this.$notify(success);
        return true;
      } catch (e) {
        const arrayOfErrors: any[] = e.response.data.errors;
        arrayOfErrors.forEach((error: any) => {
          this.showValidationError(snakeCase(error.field), snakeCase(error.rule));
        });
        return false;
      }
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("receiver:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
